import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetIntegrationSettingListPagingAndFilterRequest } from '../models/request/integrationSetting/GetIntegrationSettingListPagingAndFilterRequest';

export class IntegrationSettingService {
    static async getIntegrationSettingList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getIntegrationSettingList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/IntegrationSetting/getIntegrationSettingList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportIntegrationSettingList(inputObj: GetIntegrationSettingListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportIntegrationSettingList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/IntegrationSetting/exportIntegrationSettingList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getIntegrationSettingListPagingAndFilter(inputObj: GetIntegrationSettingListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetIntegrationSettingListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/IntegrationSetting/GetIntegrationSettingListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addIntegrationSetting(_integrationSettingId: string | undefined, _companyId: string, _integrationId: string, _text: string) {
        try {

            var inputObj = {
                integrationSettingId: _integrationSettingId,
                companyId: _companyId,
                integrationId: _integrationId,
                text: _text
            }

            console.log('SERVICE CALL - AddIntegrationSetting', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/IntegrationSetting/AddIntegrationSetting', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteIntegrationSetting(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteIntegrationSetting', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/IntegrationSetting/deleteIntegrationSetting', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getIntegrationSettingById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getIntegrationSettingById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/IntegrationSetting/getIntegrationSettingById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}